import { TFunction } from "i18next";
import { ECONTRACT_STATUS } from "../../../../../../enums";

export const getMappedContractStatus = (
  status: ECONTRACT_STATUS,
  t: TFunction<"translation", undefined>
) => {
  const statuses = {
    [ECONTRACT_STATUS.DRAFT]: {
      backgroundColor: "#EEF0F5",
      color: "#000000",
      title: t("lbl_draft"),
    },
    [ECONTRACT_STATUS.CREATED]: {
      backgroundColor: "#FFFAEB",
      color: "#D9A407",
      title: t("global_status_payment_title"),
    },
    [ECONTRACT_STATUS.SUBMITTED]: {
      backgroundColor: "#FFFAEB",
      color: "#D9A407",
      title: t("global_status_payment_title"),
    },
    [ECONTRACT_STATUS.CONTRACT_ACCEPTED]: {
      backgroundColor: "#FFFAEB",
      color: "#D9A407",
      title: t("global_status_payment_title"),
    },
    [ECONTRACT_STATUS.ADDING_PARTY]: {
      backgroundColor: "#FFFAEB",
      color: "#D9A407",
      title: t("global_status_payment_title"),
    },
    [ECONTRACT_STATUS.PARTIALLY_PAID]: {
      backgroundColor: "#FFFAEB",
      color: "#D9A407",
      title: t("global_status_payment_title"),
    },
    [ECONTRACT_STATUS.PENDING_PAYMENT_VERIFICATION]: {
      backgroundColor: "#FFFAEB",
      color: "#D9A407",
      title: t("lbl_waiting_payment_confirmation"),
    },
    [ECONTRACT_STATUS.WAITING_FOR_DELIVERY]: {
      backgroundColor: "#EBF6F4",
      color: "#00897B",
      title: t("global_status_execution_title"),
    },
    [ECONTRACT_STATUS.PARTIAL_CONFIRMED_DELIVERY]: {
      backgroundColor: "#EBF6F4",
      color: "#00897B",
      title: t("global_status_execution_title"),
    },
    [ECONTRACT_STATUS.SHIPPED]: {
      backgroundColor: "#EBF6F4",
      color: "#00897B",
      title: t("global_status_execution_title"),
    },
    [ECONTRACT_STATUS.DELIVERY_ESCALATION]: {
      backgroundColor: "#FFFAEB",
      color: "#D9A407",
      title: t("lbl_contract_details_waiting_for_escaltion_state_title"),
    },
    [ECONTRACT_STATUS.RESOLVED_REFUND_CUSTOMER]: {
      backgroundColor: "#EBF6F4",
      color: "#00897B",
      title: t("lbl_escalation_done"),
    },
    [ECONTRACT_STATUS.PARTIALLY_REFUNDED]: {
      backgroundColor: "#EBF6F4",
      color: "#00897B",
      title: t("lbl_escalation_done"),
    },
    [ECONTRACT_STATUS.RESOLVED_RELEASE_PROVIDER]: {
      backgroundColor: "#EBF6F4",
      color: "#00897B",
      title: t("lbl_escalation_done"),
    },
    [ECONTRACT_STATUS.PARTIALLY_RESOLVE_RELEASED]: {
      backgroundColor: "#EBF6F4",
      color: "#00897B",
      title: t("lbl_escalation_done"),
    },
    [ECONTRACT_STATUS.ITEM_INSPECTION]: {
      backgroundColor: "#EBF6F4",
      color: "#00897B",
      title: t("lbl_inspection"),
    },
    [ECONTRACT_STATUS.PARTIAL_ITEM_ACCEPTED]: {
      backgroundColor: "#EBF6F4",
      color: "#00897B",
      title: t("lbl_inspection"),
    },
    [ECONTRACT_STATUS.ITEM_ACCEPTED]: {
      backgroundColor: "#EBF6F4",
      color: "#00897B",
      title: t("global_status_settlement"),
    },
    [ECONTRACT_STATUS.READY_FOR_CASH_OUT]: {
      backgroundColor: "#EBF6F4",
      color: "#00897B",
      title: t("global_status_settlement"),
    },
    [ECONTRACT_STATUS.PARTIALLY_RELEASED]: {
      backgroundColor: "#EBF6F4",
      color: "#00897B",
      title: t("global_status_transfer"),
    },
    [ECONTRACT_STATUS.COMPLETED]: {
      backgroundColor: "#3ECC85",
      color: "#FFFFFF",
      title: t("global_status_finished"),
    },
    [ECONTRACT_STATUS.EXCEPTIONAL_COMPLETED]: {
      backgroundColor: "#3ECC85",
      color: "#FFFFFF",
      title: t("global_status_finished"),
    },
    [ECONTRACT_STATUS.CLOSED_REFUND_CUSTOMER]: {
      backgroundColor: "#3ECC85",
      color: "#FFFFFF",
      title: t("global_status_finished"),
    },
    [ECONTRACT_STATUS.CLOSED_RELEASE_PROVIDER]: {
      backgroundColor: "#3ECC85",
      color: "#FFFFFF",
      title: t("global_status_finished"),
    },
    [ECONTRACT_STATUS.CASH_OUT_APPROVED]: {
      backgroundColor: "#EBF6F4",
      color: "#00897B",
      title: t("global_status_transfer"),
    },
    [ECONTRACT_STATUS.PARTIAL_CASHOUT]: {
      backgroundColor: "#EBF6F4",
      color: "#00897B",
      title: t("global_status_transfer"),
    },
  };

  return statuses[status];
};
